module.exports = __webpack_public_path__ + "public/Icons/failed_payout.svg?162d8862";